import { render, staticRenderFns } from "./MetadataFieldEditor.vue?vue&type=template&id=210f00de&scoped=true&"
import script from "./MetadataFieldEditor.vue?vue&type=script&lang=js&"
export * from "./MetadataFieldEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f00de",
  null
  
)

export default component.exports